export function index(applicationId)
{
    return axios.get(route('api.manage.applications.invitations', {applicationId}))
        .then(response => response.data);
}

// export function store(applicationId, data)
// {
//     return axios.post(route('api.manage.applications.invitations.store', {applicationId}) + '?include=timeline-event,interviewInvitation.interview', data)
//         .then(response => response.data);
// }

export function storeBulk(data, filters)
{
    filters = filters || {};

    return axios.post(route('api.manage.companies.invitations.store') + '?include=timelineEvent,interviewInvitation.interview',
        data,
        {params: {...filters}}
    )
        .then(response => response.data);
}
